import { useReducer, useCallback } from 'react';

const initialState = {
  page: 0,
  hasMore: false,
  maxPageReached: 0,
};
const UPDATE = 'UPDATE';

export const paginationReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE:
      const newState = { ...state, ...action.data };
      return newState;
    default:
      return state;
  }
};

export function usePagination() {
  const [state, dispatch] = useReducer(paginationReducer, initialState);
  const updatePagination = useCallback(({ hasMore, page, maxPageReached }) => {
    dispatch({ type: UPDATE, data: { hasMore, page, maxPageReached } });
  }, []);
  return {
    page: state.page,
    hasMore: state.hasMore,
    maxPageReached: state.maxPageReached,
    updatePagination,
  };
}
